import React from 'react';
import ConvertNumber from '../components/ConvertNumber';

const SingleContractInstallment = ({
    countNumber,
    paymentPositionPrice,
    discountProcent,
    discountCash,
    paymentMonth,
    paymentDate,
    paymentPositionPriceDiscount,
    promotionsData
    
}) => {
    return (

       promotionsData > 0? 
            <tr>
            <td id="installment-number-01" className="installment-number">
                {countNumber}
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(paymentPositionPrice) } zł
            </td>
            {/* <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(discountProcent) } %
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(discountCash) } zł
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(paymentPositionPriceDiscount) } zł
            </td> */}
            {/* <td id="installment-month-01" className="installment-month">{paymentMonth}</td> */}
            <td id="installment-date-01" className="installment-date">
                {paymentDate}
            </td>
        </tr> :
        <tr>
            <td id="installment-number-01" className="installment-number">
                {countNumber}
            </td>
            <td id="installment-sum-01" className="installment-sum">
                {ConvertNumber(paymentPositionPrice) } zł
            </td>
            
            <td id="installment-date-01" className="installment-date">
                {paymentDate}
            </td>
        </tr>
    );
};
export default SingleContractInstallment;
